import React from 'react';

const Footer = () => {
    return (
        <div className="border-top border-secondary bg-light w-100 text-center small p-2">
            &copy; 2020 react-clicky-game-fc
        </div>
    );
};

export default Footer;
